/* =========================================================
   BOX IMPORT — Popup de newsletter
   Archivo: assets/box-import-popup.js
   ========================================================= */
(() => {
  if (customElements.get('bi-newsletter-popup')) return;

  const STORAGE_KEY = 'bi-newsletter';
  const storage = {
    get() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; } catch (e) { return {}; }
    },
    set(value) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(value)); } catch (e) { /* sin storage */ }
    },
  };

  class BiNewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.ac = new AbortController();
      const opts = { signal: this.ac.signal };

      this.querySelectorAll('[data-close]').forEach((btn) => btn.addEventListener('click', () => this.close(), opts));
      // clic fuera de la tarjeta
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); }, opts);
      // tecla Esc
      this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); }, opts);
      this.querySelectorAll('[data-copy]').forEach((btn) => {
        btn.addEventListener('click', () => {
          navigator.clipboard?.writeText(btn.dataset.copy).then(() => { btn.textContent = '¡Copiado!'; });
        }, opts);
      });

      // Después de enviar el formulario la página se recarga con el resultado
      if (this.querySelector('[data-success]')) {
        storage.set({ subscribed: true });
        this.open();
        return;
      }
      if (this.querySelector('[data-error]')) {
        this.open();
        return;
      }

      // Editor de Shopify: mostrar solo al seleccionar la sección
      if (this.dataset.designMode === 'true') {
        const sectionId = this.closest('.shopify-section')?.id;
        document.addEventListener('shopify:section:select', (e) => {
          if (sectionId === `shopify-section-${e.detail.sectionId}`) this.open();
        }, opts);
        document.addEventListener('shopify:section:deselect', (e) => {
          if (sectionId === `shopify-section-${e.detail.sectionId}`) this.close(true);
        }, opts);
        return;
      }

      const state = storage.get();
      const days = Number(this.dataset.days) || 7;
      if (state.subscribed) return;
      if (state.dismissedAt && Date.now() - state.dismissedAt < days * 864e5) return;

      const schedule = () => {
        this.timer = setTimeout(() => this.open(), (Number(this.dataset.delay) || 0) * 1000);
      };
      // Si la intro cinemática está en curso, esperamos a que termine
      if (document.documentElement.classList.contains('bi-intro-active')) {
        document.addEventListener('bi:intro-done', schedule, { once: true, signal: this.ac.signal });
      } else {
        schedule();
      }
    }

    disconnectedCallback() {
      this.ac?.abort();
      clearTimeout(this.timer);
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
    }

    close(silent = false) {
      if (!this.dialog.open) return;
      if (!silent && !storage.get().subscribed) storage.set({ dismissedAt: Date.now() });
      this.dialog.classList.add('is-closing');
      setTimeout(() => {
        this.dialog.classList.remove('is-closing');
        this.dialog.close();
      }, 260);
    }
  }

  customElements.define('bi-newsletter-popup', BiNewsletterPopup);
})();
